import {Link} from "react-router";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuShortcut,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu.tsx";
import {Button} from "@/components/ui/button.tsx";
import {usePlayerView} from "@/player/PlayerViewHooks.ts";
import {Check, ChevronDown, CircleAlert, ExternalLink, Image, ImageIcon, Loader2, Swords} from "lucide-react";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";

export default function PlayerViewMenu() {
    const {display, displayCampaign, loading, error} = usePlayerView()
    const {campaignPath} = useCampaign();

    const presentation = display.display === "encounter"
        ? {label: display.encounter.name, icon: Swords, iconClassName: "text-destructive"}
        : display.display === "scene"
            ? {label: display.scene.name, icon: ImageIcon, iconClassName: "text-warning"}
            : {label: "Kampagnenbild", icon: Image, iconClassName: "text-secondary"};
    const DisplayIcon = presentation.icon;
    const statusTitle = error
        ? "Spieleransicht konnte nicht aktualisiert werden"
        : loading
            ? "Spieleransicht wird synchronisiert"
            : `Spieler sehen: ${presentation.label}`;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="subtle" type="button" disabled={loading}
                        className="h-11 min-w-60 gap-2 rounded-sm border border-border/70 bg-surface-raised px-3"
                        title={statusTitle}
                        aria-label={`${statusTitle}. Menü öffnen`}>
                    {loading ? <Loader2 className="animate-spin text-muted-foreground"/>
                        : <DisplayIcon
                            className={`shrink-0 size-7 ${error ? "text-destructive" : presentation.iconClassName}`}/>
                    }
                    <span className="min-w-0 grow text-center leading-tight">
                        <span
                            className="block truncate text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
                            Aktuelle Spielerausgabe
                        </span>
                        <span className="block truncate">
                            {presentation.label}
                        </span>
                    </span>
                    {error
                        ? <CircleAlert className="shrink-0 text-destructive"/>
                        : <ChevronDown className="shrink-0 text-muted-foreground"/>
                    }
                    <span className="sr-only" aria-live="polite">{statusTitle}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-60">
                <DropdownMenuItem disabled={display.display === "campaign"}
                                  onSelect={() => void displayCampaign()}>
                    <Image className="text-secondary" />Kampagnenbild anzeigen
                    {display.display === "campaign" &&
                        <DropdownMenuShortcut><Check/></DropdownMenuShortcut>}
                </DropdownMenuItem>
                {error && <>
                    <DropdownMenuSeparator/>
                    <DropdownMenuLabel className="flex items-center gap-2 font-normal text-destructive">
                        <CircleAlert className="size-4"/>Synchronisierung fehlgeschlagen
                    </DropdownMenuLabel>
                </>}
                <DropdownMenuSeparator/>
                <DropdownMenuItem asChild>
                    <Link to={campaignPath("player")} target="_blank" rel="noreferrer">
                        <ExternalLink/>Spieleransicht öffnen
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>)
}
